import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';
import { ValidationResult } from '../utils/validation';

interface PrimesMessagesProps {
  gradeEchelonValidation: ValidationResult;
  showSuccessMessage: string | null;
  validationErrors: Record<string, string[]>;
}

export default function PrimesMessages({
  gradeEchelonValidation,
  showSuccessMessage,
  validationErrors
}: PrimesMessagesProps) {
  return (
    <>
      {/* Validation Messages */}
      {!gradeEchelonValidation.isValid && (
        <div className="mb-4 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-yellow-600" />
            <h4 className="font-medium text-yellow-800">Configuration requise</h4>
          </div>
          <ul className="mt-2 text-sm text-yellow-700 space-y-1">
            {gradeEchelonValidation.errors.map((error, index) => (
              <li key={index}>• {error}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Success Message */}
      {showSuccessMessage && (
        <div className="mb-4 p-3 bg-green-50 rounded-lg border border-green-200">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-600" />
            <span className="text-sm font-medium text-green-800">{showSuccessMessage}</span>
          </div>
        </div>
      )}

      {/* Global Validation Errors */}
      {Object.keys(validationErrors).length > 0 && (
        <div className="mb-4 p-3 bg-red-50 rounded-lg border border-red-200">
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle className="w-4 h-4 text-red-600" />
            <h4 className="font-medium text-red-800">Erreurs de validation</h4>
          </div>
          <div className="text-sm text-red-700">
            Veuillez corriger les erreurs dans les champs de saisie.
          </div>
        </div>
      )}
    </>
  );
}